import { useMutation } from "@tanstack/react-query";
import { deactivateDotdigital } from "../../api/bDotdigitalApi";

export const useDeactivateDotdigital = () => {
  return useMutation({
    mutationKey: ["deactivate-dotdigital"],
    mutationFn: (data) => deactivateDotdigital(data),
    onError: (error) => {
      console.error("Dotdigital deactivation error:", error.response || error);
    },
  });
};
